import { SetStateAction, useEffect } from 'react';
import { getRelevantCriteria } from '~/screens/MyAgency/components/FiltersDrawer/helpers';
import { useAdvancedFiltersStore } from '~/screens/MyAgency/store/useAdvancedFiltersStore';
import { FILTERS } from '~/screens/MyAgency/types';

export const useAutoSetCriteria = (
  criteriaType:
    | FILTERS.ageCriteria
    | FILTERS.genderCriteria
    | FILTERS.countryCriteria,
  setter: SetStateAction<any>,
) => {
  const { getFilter, activePlatform } = useAdvancedFiltersStore();
  const value = getFilter(activePlatform, criteriaType);

  useEffect(() => {
    // This useEffect is updates the slider preview value when the store updates
    if (!value) return;
    setter((previousState: any) => ({
      ...previousState,
      [activePlatform]: getRelevantCriteria(Number(value)),
    }));
  }, [value, activePlatform, setter]);
};
